import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

interface PaymentCardSkeletonProps {
  count?: number;
}

export const PaymentCardSkeleton = ({
  count = 2,
}: PaymentCardSkeletonProps): JSX.Element => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <Box
        key={index}
        aria-hidden
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 0.5,
          py: 0.5,
        }}
      >
        <Skeleton
          variant="rounded"
          width={40}
          height={28}
          sx={{ bgcolor: 'action.hover', flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton
            variant="text"
            width="45%"
            height={18}
            sx={{ bgcolor: 'action.hover' }}
          />
          <Skeleton
            variant="text"
            width="30%"
            height={14}
            sx={{ bgcolor: 'action.hover' }}
          />
        </Box>
        <Skeleton
          variant="circular"
          width={20}
          height={20}
          sx={{ bgcolor: 'action.hover', flexShrink: 0 }}
        />
      </Box>
    ))}
  </>
);
